import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useDevopstrioAuth } from "../context/DevopstrioAuthContext";
import {
  FiTool,
  FiActivity,
  FiMail
} from "react-icons/fi";

import MaintenancePage from "./MaintenancePage";
import MaintenanceMailStatus from "./MaintenanceMailStatus";   // ✅ NEW
import SystemMonitoring from "./SystemMonitoring";

import "../styles/DevopstrioDashboard.css";

export default function DevopstrioDashboard() {

  const { devopstrioUser, logout } = useDevopstrioAuth();
  const [activeTab, setActiveTab] = useState(() => {
    return sessionStorage.getItem("devopstrio_active_tab") || "maintenance";
  });

  useEffect(() => {
    sessionStorage.setItem("devopstrio_active_tab", activeTab);
  }, [activeTab]);


  const handleLogout = async () => {
    const res = await Swal.fire({
      title: "Confirm Logout",
      text: "Are you sure you want to logout from the dashboard?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3b82f6",
      cancelButtonColor: "#64748b"
    });

    if (res.isConfirmed) {
      sessionStorage.clear();
      logout();
    }
  };

  return (
    <div className="devopstrio-dashboard-wrapper">

      {/* HEADER */}
      <header className="devopstrio-dashboard-header">
        <div className="devopstrio-header-content">

          <div className="devopstrio-header-left">
            <div className="devopstrio-logo-container">
              <img src="/Home/devlogo.png" alt="Devopstrio" />
              <h1 className="devopstrio-header-title">Devopstrio</h1>
            </div>
          </div>

          <div className="devopstrio-header-right">
            <div className="devopstrio-user-info">
              <div className="devopstrio-user-welcome">Welcome back</div>
              <div className="devopstrio-user-email">
                {devopstrioUser?.user?.email || "-"}
              </div>
            </div>

            <button
              className="devopstrio-header-logout-btn"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>

        </div>
      </header>

      {/* MAIN */}
      <main className="devopstrio-dashboard-container">

        {/* CARD STYLE TABS */}
        <nav className="devopstrio-dashboard-tabs-card">

          {/* System Maintenance */}
          <button
            type="button"
            className={`devopstrio-tab-card ${activeTab === "maintenance" ? "active" : ""
              }`}
            onClick={() => setActiveTab("maintenance")}
          >
            <div className="tab-card-icon">
              <FiTool />
            </div>

            <div className="tab-card-text">
              <h4>System Maintenance</h4>
              <p>Add / update maintenance details</p>
            </div>

            <span className="tab-card-line" />
          </button>

          {/* Maintenance Mail Status  ✅ NEW TAB */}
          <button
            type="button"
            className={`devopstrio-tab-card ${activeTab === "mailStatus" ? "active" : ""
              }`}
            onClick={() => setActiveTab("mailStatus")}
          >
            <div className="tab-card-icon">
              <FiMail />
            </div>

            <div className="tab-card-text">
              <h4>Maintenance Mail Status</h4>
              <p>View sent maintenance emails</p>
            </div>

            <span className="tab-card-line" />
          </button>

          {/* System Monitoring */}
          <button
            type="button"
            className={`devopstrio-tab-card ${activeTab === "monitoring" ? "active" : ""
              }`}
            onClick={() => setActiveTab("monitoring")}
          >
            <div className="tab-card-icon">
              <FiActivity />
            </div>

            <div className="tab-card-text">
              <h4>System Monitoring</h4>
              <p>Track system performance</p>
            </div>

            <span className="tab-card-line" />
          </button>

        </nav>

        <div className="devopstrio-dashboard-content">

          {/* System Maintenance */}
          {activeTab === "maintenance" && (
            <div className="devopstrio-dashboard-panel">
              <div className="devopstrio-panel-header">
                <h2 className="devopstrio-panel-title">
                  System Maintenance
                </h2>
              </div>

              <MaintenancePage />
            </div>
          )}

          {/* ✅ Maintenance Mail Status */}
          {activeTab === "mailStatus" && (
            <div className="devopstrio-dashboard-panel">
              <div className="devopstrio-panel-header">
                <h2 className="devopstrio-panel-title">
                  Maintenance Mail Status
                </h2>
              </div>

              <MaintenanceMailStatus />
            </div>
          )}

          {/* System Monitoring */}
          {activeTab === "monitoring" && (
            <div className="devopstrio-dashboard-panel">
              <div className="devopstrio-panel-header">
                <h2 className="devopstrio-panel-title">
                  System Monitoring
                </h2>
              </div>

              <SystemMonitoring />
            </div>
          )}


        </div>
      </main>
    </div>
  );
}
